import { action, observable, makeObservable } from 'mobx'
import { OptionsObject } from 'notistack'

interface INotification {
  key: string
  message: string
  isShown: boolean
  options: OptionsObject
  information?: string
}

class NotificationStore {
  @observable
  public notifications: INotification[] = []
  @observable
  public isModalOpen: boolean = false
  @observable
  public modalNotification: INotification

  private lastShownTimestamps = observable.map<string, number>()

  constructor() {
    makeObservable(this)
  }

  @action.bound
  public closeDialog() {
    this.isModalOpen = false
  }

  @action.bound
  public openDialog(notification: INotification) {
    this.isModalOpen = true
    this.modalNotification = notification
  }

  @action.bound
  public sendNotification(
    key: string,
    message: string | any,
    options: OptionsObject = {},
    information?: string,
    cooldownMs: number = 10000
  ) {
    const now = Date.now()
    const stringMessage = typeof message === 'string' ? message : JSON.stringify(message)
    const normalizedMessage = stringMessage.trim().toLowerCase()
    const lastShown = this.lastShownTimestamps.get(normalizedMessage)

    if (lastShown && now - lastShown < cooldownMs) {
      return
    }

    this.lastShownTimestamps.set(normalizedMessage, now)

    const notification: INotification = {
      key,
      message: stringMessage,
      isShown: false,
      options,
      information,
    }

    this.notifications.push(notification)
  }

  @action.bound
  public markNotificationShown(key: string) {
    this.notifications.filter((n) => n.key === key).forEach((n) => (n.isShown = true))
  }

  @action.bound
  public removeNotification(key: string) {
    this.notifications = this.notifications.filter((n) => n.key !== key)
    return undefined
  }
}

export default NotificationStore
export { INotification }
